'use client';

import { HDR_WORKFLOW_STEPS } from '@rehub/pricing';

export default function HdrWorkflowStrip({
  theme = 'dark',
  className = '',
}: {
  theme?: 'dark' | 'light';
  className?: string;
}) {
  const dark = theme === 'dark';
  return (
    <ol
      className={`flex flex-wrap items-center justify-center gap-2 sm:gap-3 ${className}`}
    >
      {HDR_WORKFLOW_STEPS.map((step, index) => (
        <li key={step.id} className="flex items-center gap-2 sm:gap-3">
          <span
            className={`rounded-full px-3 py-1.5 text-sm font-semibold ${
              step.id === 'hdrphoto'
                ? dark
                  ? 'bg-sky-500 text-white'
                  : 'bg-sky-600 text-white'
                : dark
                  ? 'bg-slate-800 text-slate-200'
                  : 'bg-slate-100 text-slate-700'
            }`}
          >
            {step.label}
          </span>
          {index < HDR_WORKFLOW_STEPS.length - 1 && (
            <span className=            {dark ? 'text-slate-600' : 'text-slate-400'} aria-hidden>
              →
            </span>
          )}
        </li>
      ))}
    </ol>
  );
}
